import React from "react";
import styled from "styled-components";
import { AlertTriangle } from "lucide-react";

const ErrorWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 1rem;
  padding: 0 16px;
  padding-top: 12px;
`;

const ErrorIconBox = styled.div`
  width: 36px;
  height: 36px;
  background: #fee2e2;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
`;

const ErrorTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 4px;
`;

const ErrorDesc = styled.p`
  color: #6b7280;
  margin-bottom: 12px;
  font-size: 13px;
  text-align: center;
`;

export const SalesDashboardAverageSummaryError = () => {
  return (
    <ErrorWrapper>
      <ErrorIconBox>
        <AlertTriangle width={18} height={18} color="#dc2626" strokeWidth={2} />
      </ErrorIconBox>
      <ErrorTitle>데이터를 불러올 수 없습니다</ErrorTitle>
      <ErrorDesc>
        매출 데이터를 불러오는 중 예상치 못한 오류가 발생했습니다.
      </ErrorDesc>
    </ErrorWrapper>
  );
};
